const FINANCIAL_CREDIT_LIMIT_DEFINITION =
  "The recommended credit limit is calculated using information from a company's payment record and from the payment records of similar companies. The company credit limit is our recommendation of the total maximum amount of credit that should outstanding at any one time.";

export default FINANCIAL_CREDIT_LIMIT_DEFINITION;
